export default __webpack_public_path__ + "static/media/downArrow.0d00d94e.svg";